import React from 'react';
import * as dateFns from 'date-fns';
import { PickerRowsProps } from './types';

const NUMBER_OF_WEEK_DAYS = 7;

const PickerCalendarRows = ({ selectedDate, click , viewDate } : PickerRowsProps) => {

  const rows = [];
  let days = [];
  let day = dateFns.startOfWeek(dateFns.startOfMonth(viewDate));

  while (day <= dateFns.endOfWeek(dateFns.endOfMonth(viewDate))) {
    for (let i = 0; i < NUMBER_OF_WEEK_DAYS; i++) {
      const copyDay = day;
      copyDay.setHours(7);
      // three kinds of cell: selected, disabled, nothing
      const isSelected = dateFns.isSameDay(copyDay, selectedDate);
      const isDisabled = !dateFns.isSameMonth(day, viewDate);
      
      const classNameSuffix = isSelected
      ? 'small-month-row-cell-selected'
      : isDisabled
      ? 'small-month-row-cell-disabled'
      : '';
      days.push(
        <div
          className={'small-month-row-cell ' + classNameSuffix}
          key={'' + day}
          onClick={() => (click(copyDay))}
        >
          {dateFns.format(new Date(day), 'd')} {/*<label className="calendar-point"/>*/}
        </div>
      );
      day = dateFns.addDays(day, 1);
    }
    rows.push(
      <div className="small-month-row" key={'' + day}>
        {days}
      </div>
    );
    days = [];
  }
  return (
    <div>
      {rows}
    </div>
  );
};

export default PickerCalendarRows;